// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"FX-z","sponsoredTooltipWrapper":"GX-z","sponsoredTooltip":"HX-z","newCard":"IX-z"};